import { useEffect, useState } from "react";

/**
 * Returns `window.location.origin`
 *
 * TODO: Consider renaming or refactoring this function
 */

export const useHostname = () => {
    const [hostname, setHostname] = useState("");

    useEffect(() => {
        if (!hostname) {
            setHostname(window.location.origin);
        }
    }, [hostname]);

    return hostname;
};
